module.exports = __webpack_public_path__ + "static/school_support_referenceM@2x-55538617cbdae99ce0dbae0c5a6cc962.png";